export const DOCUMENT_TITLE_MAX_LENGTH = 100;

export const MAX_GROUP_SIZE = 3;
